import { CompetitorComparison } from '../../../types/industry/Industry'

export const SET_COMPETITOR_COMPARISON_DATA = 'SET_COMPETITOR_COMPARISON_DATA'

export interface SetCompetitorComparisonData {
  type: typeof SET_COMPETITOR_COMPARISON_DATA
  payload: CompetitorComparison
}
